/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAvailableProjectItemsQuery } from '../../models/get-available-project-items-query';
import { GetAvailableProjectItemsQueryResult } from '../../models/get-available-project-items-query-result';

export interface ApiProjectItemSamplesGetAvailableProjectItemsPost$Params {
      body?: GetAvailableProjectItemsQuery
}

export function apiProjectItemSamplesGetAvailableProjectItemsPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAvailableProjectItemsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesGetAvailableProjectItemsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAvailableProjectItemsQueryResult>;
    })
  );
}

apiProjectItemSamplesGetAvailableProjectItemsPost.PATH = '/api/ProjectItemSamples/GetAvailableProjectItems';
